import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { NewRepChecklistModel } from '../../new-rep-checklist/new-rep-checklist-models/new-rep-checklist.model';

@Injectable({
  providedIn: 'root'
})
export class NewIntroducerChecklistService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async viewChecklistdocuments(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.viewchecklistdocuments + `/${viewid}`;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/pdf',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return new Blob([httpResponse.data], {
          type: 'application/pdf'
        });
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async viewChecklistdocumentslist(viewid: number, designation: string) {

    const API_URL: string = environment.baseUrl + environment.apis.viewdocumentslist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        onboardingId: viewid,
        updatedByRole: [designation]
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async savenewRepChecklistItems(newRepChecklist: NewRepChecklistModel) {

    const API_URL: string = environment.baseUrl + environment.apis.savenewRepChecklist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: newRepChecklist.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getChecklistItems(viewid: number) {

    const API_URL: string = environment.baseUrl + environment.apis.getchecklistItems;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "onboarding_id": viewid,
        "updated_by_role": this.sessionStorageService.getCurrentUserRole(),
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}
